(function () {
  var toastEl = document.getElementById('ie-toast');
  var toastTimer;

  function showToast(message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.hidden = true;
    }, 2200);
  }

  function updateCartCount(count) {
    var n = Number(count) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  /* ---- Sticky-Header: sanfter Schatten beim Scrollen ---- */
  var headerEl = document.querySelector('[data-ie-header]');
  if (headerEl) {
    var onScroll = function () {
      headerEl.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile drawer ---- */
  var drawer = document.querySelector('[data-ie-drawer]');
  var overlay = document.querySelector('[data-ie-drawer-overlay]');
  var burger = document.querySelector('[data-ie-drawer-open]');

  function openDrawer() {
    if (!drawer || !overlay) return;
    overlay.hidden = false;
    // allow the element to render before transitioning
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('ie-no-scroll');
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('ie-no-scroll');
    setTimeout(function () { overlay.hidden = true; }, 320);
  }

  if (burger) burger.addEventListener('click', openDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.querySelectorAll('[data-ie-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* Cross-component messaging: sections can dispatch these instead of
     depending on load order relative to this file. */
  document.addEventListener('ie:toast', function (e) {
    if (e.detail && e.detail.message) showToast(e.detail.message);
  });
  document.addEventListener('ie:cart-count', function (e) {
    if (e.detail && typeof e.detail.count !== 'undefined') updateCartCount(e.detail.count);
  });

  /* ---- Desktop nav dropdowns (touch + keyboard support) ---- */
  document.querySelectorAll('[data-nav-dropdown]').forEach(function (item) {
    var trigger = item.querySelector('.ie-navitem__trigger');
    if (!trigger) return;

    function isTouch() { return matchMedia('(hover: none)').matches; }

    trigger.addEventListener('click', function (e) {
      if (!isTouch()) return;
      if (!item.classList.contains('is-open')) {
        e.preventDefault();
        document.querySelectorAll('[data-nav-dropdown].is-open').forEach(function (o) {
          if (o !== item) { o.classList.remove('is-open'); o.querySelector('.ie-navitem__trigger').setAttribute('aria-expanded', 'false'); }
        });
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    item.addEventListener('focusin', function () { trigger.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-nav-dropdown].is-open').forEach(function (item) {
      if (!item.contains(e.target)) {
        item.classList.remove('is-open');
        item.querySelector('.ie-navitem__trigger').setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ---- Mobile drawer accordion ---- */
  document.querySelectorAll('[data-drawer-group]').forEach(function (group) {
    var toggle = group.querySelector('[data-drawer-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var isOpen = group.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  /* ---- Scroll-reveal animation ---- */
  var revealTargets = document.querySelectorAll('.ie-reveal');
  if ('IntersectionObserver' in window && revealTargets.length) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealTargets.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains('ie-add-to-cart-form')) return;

    event.preventDefault();

    var productCard = form.closest('.ie-product');
    var productName = '';
    if (productCard) {
      productName = productCard.querySelector('.ie-product__name').textContent.trim();
    } else if (form.getAttribute('data-product-title')) {
      productName = form.getAttribute('data-product-title');
    }
    var formData = new FormData(form);
    var variantId = formData.get('id');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (response) {
        if (response.status === 422) {
          return correctStockAfterFailedAdd(form, variantId).then(function () {
            throw new Error('handled_422');
          });
        }
        if (!response.ok) throw new Error('add_to_cart_failed');
        return fetch('/cart.js');
      })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        showToast((productName || 'Produkt') + ' wurde in den Warenkorb gelegt');
      })
      .catch(function (err) {
        if (err && err.message === 'handled_422') return;
        showToast('Das hat leider nicht geklappt. Bitte versuche es erneut.');
      });
  });

  /* After Shopify rejects an add for insufficient stock, fetch the real inventory
     and correct the product-page quantity field + button state. */
  function correctStockAfterFailedAdd(form, variantId) {
    var handle = form.getAttribute('data-product-handle');
    var qtyInput = form.querySelector('[data-qty-input]');
    var addBtn = form.querySelector('[data-add-btn]');
    var addBtnText = form.querySelector('[data-add-btn-text]');
    if (!handle || !qtyInput) {
      showToast('Von diesem Produkt ist leider nicht mehr genug auf Lager.');
      return Promise.resolve();
    }
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = (product.variants || []).filter(function (v) {
          return String(v.id) === String(variantId);
        })[0];
        if (!variant) return;
        var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
        if (!variant.available) {
          qtyInput.value = min;
          qtyInput.setAttribute('data-max-qty', 0);
          if (addBtn) addBtn.disabled = true;
          if (addBtnText) addBtnText.textContent = 'Ausverkauft';
          showToast('Dieses Produkt ist leider ausverkauft.');
          return;
        }
        if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
          var max = Math.max(0, variant.inventory_quantity);
          var requested = parseInt(qtyInput.value, 10) || min;
          qtyInput.setAttribute('data-max-qty', max);
          qtyInput.value = Math.max(min, Math.min(requested, max));
          showToast('Nur noch ' + max + ' Stück verfügbar, Menge angepasst.');
        } else {
          showToast('Von diesem Produkt ist leider nicht mehr genug auf Lager.');
        }
      })
      .catch(function () {
        showToast('Von diesem Produkt ist leider nicht mehr genug auf Lager.');
      });
  }
})();

/* Produktkarte: Hover über einen Farbkreis zeigt das Bild dieser Farbe */
(function () {
  document.querySelectorAll('.ie-product__swatches').forEach(function (wrap) {
    var card = wrap.closest('.ie-product');
    if (!card) return;
    var img = card.querySelector('.ie-product__img--primary');
    if (!img) return;

    function preview(src) {
      if (!img.getAttribute('data-orig-src')) {
        img.setAttribute('data-orig-src', img.getAttribute('src') || '');
        var ss = img.getAttribute('srcset');
        if (ss) img.setAttribute('data-orig-srcset', ss);
      }
      img.removeAttribute('srcset');
      img.setAttribute('src', src);
      card.classList.add('is-swatch-preview');
    }
    function restore() {
      var orig = img.getAttribute('data-orig-src');
      if (orig) {
        img.setAttribute('src', orig);
        var oss = img.getAttribute('data-orig-srcset');
        if (oss) img.setAttribute('srcset', oss);
      }
      card.classList.remove('is-swatch-preview');
    }

    wrap.addEventListener('mouseover', function (e) {
      var sw = e.target.closest('.ie-product__swatch');
      if (!sw) return;
      var src = sw.getAttribute('data-variant-image');
      if (src) preview(src);
    });
    wrap.addEventListener('mouseleave', restore);
  });
})();

/* Footer-Illustration bündig: Höhe = Balkenhöhe + gewünschter Überstand,
   damit sie unten exakt abschliesst. Die Breite wird begrenzt, damit die
   Illustration auf schmalen Bildschirmen den Footer nicht überdeckt. */
(function () {
  var footer = document.querySelector('.ie-footer--animal-bottom');
  if (!footer) return;
  var animal = footer.querySelector('.ie-footer__animal');
  if (!animal) return;

  function num(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }

  function apply() {
    if (!animal.naturalWidth || !animal.naturalHeight) return;
    var styles = getComputedStyle(footer);
    var isMobile = window.matchMedia('(max-width: 800px)').matches;

    var peek = num(styles.getPropertyValue(isMobile ? '--ie-animal-peek-m' : '--ie-animal-peek'), isMobile ? 52 : 78);
    var capPercent = num(styles.getPropertyValue(isMobile ? '--ie-animal-maxw-m' : '--ie-animal-maxw'), isMobile ? 45 : 26);

    var ratio = animal.naturalHeight / animal.naturalWidth;
    var wanted = footer.offsetHeight + peek;
    var maxWidth = document.documentElement.clientWidth * (capPercent / 100);
    var maxHeight = maxWidth * ratio;

    footer.style.setProperty('--ie-animal-h', Math.round(Math.min(wanted, maxHeight)) + 'px');
  }

  if (animal.complete) { apply(); } else { animal.addEventListener('load', apply); }
  window.addEventListener('resize', apply);
  window.addEventListener('load', apply);
  if ('ResizeObserver' in window) { new ResizeObserver(apply).observe(footer); }
})();

/* Text auf eine Zeile: die Schriftgrösse wird so weit verkleinert, bis der Text
   in eine Zeile passt. Wird sie dabei kleiner als der Mindestwert, darf der Text
   wieder normal umbrechen, damit er auf schmalen Bildschirmen lesbar bleibt. */
(function () {
  var nodes = document.querySelectorAll('[data-fit-line]');
  if (!nodes.length) return;

  function fit(el) {
    var min = parseFloat(el.getAttribute('data-fit-min')) || 14;
    el.classList.remove('is-wrapped');
    el.style.fontSize = '';
    var base = parseFloat(getComputedStyle(el).fontSize);
    if (!base) return;

    var avail = el.clientWidth;
    var needed = el.scrollWidth;
    if (!avail || !needed || needed <= avail) return;

    var size = Math.floor(base * (avail / needed) * 10) / 10;
    var guard = 0;
    while (guard++ < 40) {
      if (size < min) { el.classList.add('is-wrapped'); el.style.fontSize = ''; return; }
      el.style.fontSize = size + 'px';
      if (el.scrollWidth <= el.clientWidth) return;
      size -= 0.5;
    }
    el.classList.add('is-wrapped');
    el.style.fontSize = '';
  }

  function fitAll() {
    for (var i = 0; i < nodes.length; i++) fit(nodes[i]);
  }

  fitAll();
  window.addEventListener('resize', fitAll);
  window.addEventListener('load', fitAll);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fitAll); }
})();
